import { CATEGORIE_LIST_API } from "@/utils/apiUrl";
import backend from "@/utils/backend";
import * as types from "./mutation_types";

export const getAll = ({ commit }) => {
  commit(types.SET_SHOW_LOADING);
  backend({ url: CATEGORIE_LIST_API, data: null, method: "GET" })
    .then(({ data }) => {
      const response = data?.data ?? data;
      commit(types.SET_ITEMS, response);
      //  filtre pour recuperer les categorie sans les sous categories
      const raisons = response
        // .filter((categorie) => !categorie.completename.includes("E-SERVICES >"))
        .map((item) => ({
          id: item.id,
          name: item.name,
          completename: item.completename,
        }));
      //  filtre pour recuperer  les sous categorie  sans les categories

      const options = response
        .filter((categorie) => categorie.completename.includes("E-SERVICES >"))
        .map((item) => ({
          id: item.id,
          name: item.name,
          detail: item.completename || "",
          completename: item.completename,
        }));

      commit(types.SET_RAISONS, raisons);
      commit(types.SET_OPTIONS, options);

      commit(types.SET_IS_SUCCESS);
      commit(types.SET_PAGINATION, { ...(data?.data ?? data), data: null });
      commit(types.SET_MESSAGE, data.message ?? "Super");
      commit(types.SET_CURRENT_ITEM, null);
    })
    .catch((err) => {
      commit(types.SET_IS_ERROR);
      commit(types.SET_PAGINATION, null);
      commit(types.SET_SHOW_MESSAGE);
      commit(types.SET_CURRENT_ITEM, null);
      commit(types.SET_MESSAGE, err?.response?.message ?? err.message ?? err);
    })
    .finally(() => {
      commit(types.SET_SHOW_MESSAGE);
      commit(types.SET_HIDE_LOADING);
    });
};

export const resetData = ({ commit }) => {
  commit(types.RESET);
};
